module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo18-3819f47cc9c717a75634f88a6a796fd2.jpg";